import React from "react";
import classnames from "classnames";
import map from "lodash/map";

import { licenses, licensesDisplay, constToCSS } from "../../reducers/download";

const LicenseDisplay = props => {
    let { license, current } = props;

    let licenseDisplay = licensesDisplay[license];

    if (!licenseDisplay) {
        return null;
    }

    let licenseClass = classnames("license-choice", {
        current: current == license,
        "blue-choice": license == licenses.ROYALTY_FREE
    });

    let notes = map(licenseDisplay.notes, (note, i) => {
        let className, text;
        if (note.className) {
            className = note.className;
            text = note.text;
        } else {
            text = note;
        }
        className = classnames(className, {
            "with-class": !!className
        });
        return (
            <li key={i} className={className}>
                <span>{text}</span>
            </li>
        );
    });

    let action;
    if (props.onSelect) {
        action = props.onSelect.bind(null, licenses[license]);
    }

    let headerClass = classnames(
        "license-icon",
        `license-${constToCSS(license)}`
    );
    return (
        <li className={licenseClass} onClick={action}>
            <div className="text-wrapper">
                <h2 className={headerClass}>{licenseDisplay.title}</h2>
                <ul className="license-choice-notes">{notes}</ul>
            </div>
        </li>
    );
};

export default LicenseDisplay;
